import {
    PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH,
    PROJECTS_PARENTS_SUCCESSFUL_FETCH,
    SHOW_ERROR_MESSAGE,
    PROJECTS_SUCCESSFUL_YEARSTERM,
    PROJECTS_SUCCESSFUL_CAMPAIGN
} from 'reducers/constants';

import HttpClient from "utils/HttpClient/HttpClient"

export const fetchParentProjects = () => dispatch => {
    new HttpClient(true).get("oga/projects/parents")
        .then((response) => {
            dispatch({
                type: PROJECTS_PARENTS_SUCCESSFUL_FETCH,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}

export const fetchCommercialProjects = (projectParentId) => dispatch => {
    let queryProjectParentId = projectParentId != null ? "?projectParentId=" + projectParentId : "";
    new HttpClient(true).get("oga/projects" + queryProjectParentId)
        .then((response) => {
            dispatch({
                type: PROJECTS_COMMERCIAL_SUCCESSFUL_FETCH,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}

export const fetchYearsTerm = (projectId) => dispatch => {
    new HttpClient(true).get("oga/projects/yearsterm",
        {
            params: {
                projectId: projectId
            }
        })
        .then((response) => {
            dispatch({
                type: PROJECTS_SUCCESSFUL_YEARSTERM,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.message
            });
        });
}

    export const fetchCampaign = (projectId) => dispatch => {
        new HttpClient(true).get("oga/projects/campaign",
            {
                params: {
                    projectId: projectId
                }
            })
            .then((response) => {
                dispatch({
                    type: PROJECTS_SUCCESSFUL_CAMPAIGN,
                    payload: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: SHOW_ERROR_MESSAGE,
                    payload: error.message
                });
            });
}


// WEBPACK FOOTER //
// ./src/reducers/project/projectActions.js